import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import FadeIn from "@/components/FadeIn";

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);

  return (
    <>
      <SEO title="Travel Blog | Happy Holidays Wale" description="Travel tips, destination guides and inspiration for your next holiday." />
      <div className="bg-navy py-14" style={{ backgroundColor: "#002244" }}>
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Travel Blog</h1>
          <p className="mt-3 text-white/70">Guides, tips and stories to inspire your journeys.</p>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8">
        {posts === null ? (
          <div className="grid gap-6 md:grid-cols-3">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-80 skeleton rounded-3xl" />)}</div>
        ) : posts.length === 0 ? (
          <p className="py-20 text-center text-gray-500" data-testid="blog-empty">No articles published yet. Check back soon!</p>
        ) : (
          <div className="grid gap-6 md:grid-cols-3">
            {posts.map((p, i) => (
              <FadeIn key={p.id} delay={i * 0.04}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block overflow-hidden rounded-3xl bg-white card-soft hover-lift">
                  <div className="aspect-[16/10] overflow-hidden"><img src={p.cover_image} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>
                  <div className="p-6">
                    <div className="mb-2 flex flex-wrap gap-2">{(p.tags || []).slice(0, 2).map((t) => <span key={t} className="rounded-full bg-brandorange/10 px-2.5 py-1 text-xs font-semibold text-brandorange">{t}</span>)}</div>
                    <h3 className="font-display text-xl font-bold text-navy line-clamp-2">{p.title}</h3>
                    <p className="mt-2 line-clamp-2 text-sm text-gray-500">{p.excerpt}</p>
                    <div className="mt-4 flex items-center justify-between text-sm">
                      <span className="flex items-center gap-1 text-gray-400"><Calendar className="h-4 w-4" /> {new Date(p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
                      <span className="flex items-center gap-1 font-semibold text-brandorange">Read <ArrowRight className="h-4 w-4" /></span>
                    </div>
                  </div>
                </Link>
              </FadeIn>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
